// import store from '@/store';
// import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
// import FIELD_NAMES from '@/forms/constants/field-names';
// GENERIC CONSTANTS
const GENERIC_TITLE = 'Oops...';
const GENERIC_SUBTITLE = "It seems that this page is not what you're looking for";

const END_PAGE_OPS = GENERIC_TITLE;
// const getProduct=()=>{
//   const { state } = store;
//   const {  formData: { values } } = state;
//   const salesProduct = getValueByFieldName(values, FIELD_NAMES.product);
//   let formtoGo;
//   if(salesProduct.toLowerCase()==='stp card')
//   {
//     formtoGo='STP Card'
//   }
//   else if(salesProduct.toLowerCase()==='credit card')
//   {
// formtoGo='Deem | Credit Card Application';
//   }
//   return formtoGo;
// }
const FIELD_NAMES = {
    spending: 'spending',
    salary: 'salary',
    rewards: 'rewards',
    use: 'use',
    uselong: 'uselong',
    other: 'other',
    howmuch: 'howmuch',
    instalments: 'instalments',
    income: 'income',
};

// VALUES
const SPENDING = [{
        value: 'Paying straight away',
        label: 'Paying straight away',
    },
    {
        value: 'Deferring payments',
        label: 'Deferring payments',
    },
];
const YESNO = [{
        value: 'Y',
        label: 'Yes',
    },
    {
        value: 'N',
        label: 'No',
    },
];
const REWARDSTYPE = [{
        value: 'Cash Up for cashback',
        label: 'Cash Up for cashback',
    },
    {
        value: 'Miles Up for travel rewards',
        label: 'Miles Up for travel rewards',
    },
];
const USE = [{
        value: 'Buy/Renovate Property',
        label: 'Buy/Renovate Property',
    },
    {
        value: 'Make a large purchase',
        label: 'Make a large purchase',
    },
    {
        value: 'Buy a car/vehicle',
        label: 'Buy a car/vehicle',
    },
    {
        value: 'Send money to home country',
        label: 'Send money to home country',
    },
    {
        value: 'Medical expenses',
        label: 'Medical expenses',
    },
    {
        value: 'Educate my children',
        label: 'Educate my children',
    },
    {
        value: 'Pay off other debts',
        label: 'Pay off other debts',
    },
    {
        value: 'Business expenses',
        label: 'Business expenses',
    },
    {
        value: 'Other',
        label: 'Other',
    },
];
const INSURANCE = [{
        value: 'Savings Plan',
        label: 'Savings Plan',
    },
    {
        value: 'Protection Plan',
        label: 'Protection Plan',
    },

];
const CARD_USE = [{
        value: 'Everyday spend',
        label: 'Everyday spend',
    },
    {
        value: 'Shopping and Lifestyle',
        label: 'Shopping and Lifestyle',
    },
];
const CARD_USE_LONG = [{
        value: 'Everyday spend',
        label: 'Everyday spend',
    },
    {
        value: 'Shopping and Lifestyle',
        label: 'Shopping and Lifestyle',
    },
    {
        value: 'Travel',
        label: 'Travel',
    },
];
const INCOME = [{
        value: 'Less than AED 10,000',
        label: 'Less than AED 10,000',
    },
    {
        value: 'AED 10,000 - AED 25,000',
        label: 'AED 10,000 - AED 25,000',
    },
    {
        value: 'More than AED 25,000',
        label: 'More than AED 25,000',
    },
];

// CONTENT
const FEATURES_NBC_CARDS = [{
        title: 'Store Value Card',
        subtitle: 'If your monthly income is 5-10K AED',
        image: '/img/assets/card/Titanium Cash Up.jpg',
        onboarding_form: 'Stored Value Card',
        features: [
            '4% earning interest',
            'Multicurrency balance',
            'Transaction facilities',
            '[brand] Credit Shield plus',
            '1 supplementary card free',
        ],
        benefits: {
            legend: 'Store Value Card benefits',
            title: 'Store Value Card',
            items: [{
                    title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    image: '/img/assets/benefits/slide-004.png',
                    content: 'Sed a nisi vulputate, auctor odio ut, suscipit dui. Etiam in sem a ipsum dignissim euismod id nec tellus. Nunc dictum enim eros, vitae egestas velit pulvinar sed. Etiam aliquam libero sit amet ultrices commodo.',
                },
                {
                    title: 'Pellentesque maximus mauris ut molestie suscipit.p',
                    image: '/img/assets/benefits/slide-005.png',
                    content: 'Nam a quam ac libero cursus finibus. Sed sed sem hendrerit, ultrices arcu sit amet, egestas elit. Phasellus tempor neque metus, sed rhoncus odio pellentesque at. Nam blandit lacus vel elit faucibus, eu tincidunt leo ultricies. Maecenas fermentum elementum leo tempus scelerisque. Ut mauris odio, interdum et euismod quis, iaculis ut est.',
                },
            ],
        },
    },
    {
        title: 'World Miles Up',
        subtitle: 'If your monthly income is 25+K AED',
        image: '/img/assets/card/World Miles Up.jpg',
        onboarding_form: 'Deem | Credit Card Application', //'Credit Card',
        best: 'BEST FOR YOU',
        features: [
            '5x on airline tickets',
            '5x on hotel reservations',
            '5x on international spend in foreign currencies',
            '1.5x on local spend made in AED',
            'Complimentary valet parking service from Valtrans',
            'Access to 1,100+ airport lounges around the world',
            'Enjoy attractive deals and discounts with the Deem Offers app'
        ],
        benefits: {
            legend: 'all benefits',
            title: 'World cashpoints card',
            items: [{
                    title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    image: '/img/assets/benefits/slide-006.png',
                    content: 'Sed a nisi vulputate, auctor odio ut, suscipit dui. Etiam in sem a ipsum dignissim euismod id nec tellus. Nunc dictum enim eros, vitae egestas velit pulvinar sed. Etiam aliquam libero sit amet ultrices commodo.',
                },
                {
                    title: 'Pellentesque maximus mauris ut molestie suscipit.p',
                    image: '/img/assets/benefits/slide-007.png',
                    content: 'Nam a quam ac libero cursus finibus. Sed sed sem hendrerit, ultrices arcu sit amet, egestas elit. Phasellus tempor neque metus, sed rhoncus odio pellentesque at. Nam blandit lacus vel elit faucibus, eu tincidunt leo ultricies. Maecenas fermentum elementum leo tempus scelerisque. Ut mauris odio, interdum et euismod quis, iaculis ut est.',
                },
            ],
        },
    },
    {
        title: 'Platinum Miles Up',
        subtitle: 'If your monthly income is 10-25K AED',
        image: '/img/assets/card/Platinum Miles Up.jpg',
        onboarding_form: 'Deem | Credit Card Application', //'Credit Card',
        best: 'BEST FOR YOU',
        features: [
            '3x on airline tickets',
            '3x on hotel reservations',
            '3x on shopping at stores and online, worldwide',
            '1x on all retail spend worldwide',
            'Complimentary valet parking service from Valtrans',
            'Enjoy attractive deals and discounts with the Deem Offers app',
        ],
        benefits: {
            legend: 'all benefits',
            title: 'Platinum cashpoints card',
            items: [{
                    title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    image: '/img/assets/benefits/slide-008.png',
                    content: 'Sed a nisi vulputate, auctor odio ut, suscipit dui. Etiam in sem a ipsum dignissim euismod id nec tellus. Nunc dictum enim eros, vitae egestas velit pulvinar sed. Etiam aliquam libero sit amet ultrices commodo.',
                },
                {
                    title: 'Pellentesque maximus mauris ut molestie suscipit.p',
                    image: '/img/assets/benefits/slide-009.png',
                    content: 'Nam a quam ac libero cursus finibus. Sed sed sem hendrerit, ultrices arcu sit amet, egestas elit. Phasellus tempor neque metus, sed rhoncus odio pellentesque at. Nam blandit lacus vel elit faucibus, eu tincidunt leo ultricies. Maecenas fermentum elementum leo tempus scelerisque. Ut mauris odio, interdum et euismod quis, iaculis ut est.',
                },
            ],
        },
    },
    {
        title: 'Titanium Miles Up',
        subtitle: 'If your monthly income is 5-10K AED',
        image: '/img/assets/card/Titanium Miles Up.jpg',
        onboarding_form: 'Deem | Credit Card Application', //'Credit Card',
        best: 'BEST FOR YOU',
        features: [
            '2x on airline tickets ',
            '2x on hotel reservations',
            '2x at supermarkets and grocery stores, worldwide',
            '0.5x on all other retail spend worldwide',
            'Enjoy attractive deals and discounts with the Deem Offers app',
        ],
        benefits: {
            legend: 'all benefits',
            title: 'Titanium cashpoints card',
            items: [{
                    title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    image: '/img/assets/benefits/slide-006.png',
                    content: 'Sed a nisi vulputate, auctor odio ut, suscipit dui. Etiam in sem a ipsum dignissim euismod id nec tellus. Nunc dictum enim eros, vitae egestas velit pulvinar sed. Etiam aliquam libero sit amet ultrices commodo.',
                },
                {
                    title: 'Pellentesque maximus mauris ut molestie suscipit.p',
                    image: '/img/assets/benefits/slide-007.png',
                    content: 'Nam a quam ac libero cursus finibus. Sed sed sem hendrerit, ultrices arcu sit amet, egestas elit. Phasellus tempor neque metus, sed rhoncus odio pellentesque at. Nam blandit lacus vel elit faucibus, eu tincidunt leo ultricies. Maecenas fermentum elementum leo tempus scelerisque. Ut mauris odio, interdum et euismod quis, iaculis ut est.',
                },
            ],
        },
    },
    {
        title: 'World Cash Up',
        subtitle: 'If your monthly income is 25+K AED',
        image: '/img/assets/card/50thWorldsCC.JPG',
        onboarding_form: 'Deem | Credit Card Application', //'Credit Card',
        best: 'BEST FOR YOU',
        features: [
            'Free for life',
            'Up to 10% on airline tickets ',
            'Up to 5% on hotel reservations',
            'Up to 5% on entertainment spend',
            '1% on all other retail spend worldwide',
            'Complimentary valet parking service from Valtrans',
            'Access to 1,100+ airport lounges around the world',
            'Enjoy attractive deals and discounts with the Deem Offers app',
        ],
        benefits: {
            legend: 'all benefits',
            title: 'World cashpoints card',
            items: [{
                    title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    image: '/img/assets/benefits/slide-005.png',
                    content: 'Sed a nisi vulputate, auctor odio ut, suscipit dui. Etiam in sem a ipsum dignissim euismod id nec tellus. Nunc dictum enim eros, vitae egestas velit pulvinar sed. Etiam aliquam libero sit amet ultrices commodo.',
                },
                {
                    title: 'Pellentesque maximus mauris ut molestie suscipit.p',
                    image: '/img/assets/benefits/slide-009.png',
                    content: 'Nam a quam ac libero cursus finibus. Sed sed sem hendrerit, ultrices arcu sit amet, egestas elit. Phasellus tempor neque metus, sed rhoncus odio pellentesque at. Nam blandit lacus vel elit faucibus, eu tincidunt leo ultricies. Maecenas fermentum elementum leo tempus scelerisque. Ut mauris odio, interdum et euismod quis, iaculis ut est.',
                },
            ],
        },
    },

    {
        title: 'Platinum Cash Up',
        subtitle: 'If your monthly income is 10-25K AED',
        image: '/img/assets/card/Platinum Cash Up.jpg',
        onboarding_form: 'Deem | Credit Card Application', //'Credit Card',
        best: 'BEST FOR YOU',
        features: [
            'Free for Life',
            'Up to 10% Cash Up at department stores',
            'Up to 5% Cash Up on online shopping',
            'Up to 5% Cash Up on entertainment spend',
            '1% on all other retail spends',
            'Discounts on dining, leisure and more with the Deem Offers app',
            'Redeem Cash Up for cashback, pay with points and more',

        ],
        benefits: {
            legend: 'all benefits',
            title: 'Platinum cashpoints card',
            items: [{
                    title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    image: '/img/assets/benefits/slide-006.png',
                    content: 'Sed a nisi vulputate, auctor odio ut, suscipit dui. Etiam in sem a ipsum dignissim euismod id nec tellus. Nunc dictum enim eros, vitae egestas velit pulvinar sed. Etiam aliquam libero sit amet ultrices commodo.',
                },
                {
                    title: 'Pellentesque maximus mauris ut molestie suscipit.p',
                    image: '/img/assets/benefits/slide-007.png',
                    content: 'Nam a quam ac libero cursus finibus. Sed sed sem hendrerit, ultrices arcu sit amet, egestas elit. Phasellus tempor neque metus, sed rhoncus odio pellentesque at. Nam blandit lacus vel elit faucibus, eu tincidunt leo ultricies. Maecenas fermentum elementum leo tempus scelerisque. Ut mauris odio, interdum et euismod quis, iaculis ut est.',
                },
            ],
        },
    },
    {
        title: 'Titanium Cash Up',
        subtitle: 'If your monthly income is 5-10K AED',
        image: '/img/assets/card/Titanium Cash Up.jpg',
        onboarding_form: 'Deem | Credit Card Application', //'Credit Card',
        best: 'BEST FOR YOU',
        features: [
            'First year free',
            'Up to 3% Cash Up at supermarkets',
            'Up to 3% Cash Up on utilities',
            '3% Cash Up on fuel',
            '0.5% on all other retail spends',
            'Discounts on dining and more with the Deem Offers app',
            'Redeem Cash Up for cashback, pay with points and more'
        ],
        benefits: {
            legend: 'all benefits',
            title: 'Titanium cashpoints card',
            items: [{
                    title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    image: '/img/assets/benefits/slide-004.png',
                    content: 'Sed a nisi vulputate, auctor odio ut, suscipit dui. Etiam in sem a ipsum dignissim euismod id nec tellus. Nunc dictum enim eros, vitae egestas velit pulvinar sed. Etiam aliquam libero sit amet ultrices commodo.',
                },
                {
                    title: 'Pellentesque maximus mauris ut molestie suscipit.p',
                    image: '/img/assets/benefits/slide-008.png',
                    content: 'Nam a quam ac libero cursus finibus. Sed sed sem hendrerit, ultrices arcu sit amet, egestas elit. Phasellus tempor neque metus, sed rhoncus odio pellentesque at. Nam blandit lacus vel elit faucibus, eu tincidunt leo ultricies. Maecenas fermentum elementum leo tempus scelerisque. Ut mauris odio, interdum et euismod quis, iaculis ut est.',
                },
            ],
        },
    },
];
const FEATURES_LOAN = [{
    title: 'Personal Loan',
    interest: 19.99,
    subtitle: 'If your monthly income is 25+K AED',
    image: '/img/assets/card/card-world.png',
    onboarding_form: 'Deem | Loan Application', //'Loan eligibility',
    best: 'BEST FOR YOU',
    features: [
        'Accelerated X3% cashpoints based on T&E spend on: airline tickets, travel agencies, hotel room nights, tourist attractions and entertainment.',
        'Basic Y3% cashback points accrual on other retal spend.',
        'Dining: discounts on Zomato Gold.',
        'Entertainment: discounts onspa & salons, kids entertainment, cinema and gym offers.',
        'Option of a free card or fee based card.',
        'Transport: discounts on Careem and Hertz Gold Plus membership.',
        'Travel: Discounts on Cleartrip. Airport lounge access. International shopping offers. My US premium membership discounts. SPG Hotels complimentary nights. Discounts on luxury hotel apartment. Spa offers across Fairmont, Raffles & Swissotel. Hertz Gold membership.',
        'Free Valet Parking at malls & dining hotspots and free airport transfers.',
        'Protection: xbrand double secure.',
        'Up to 4 supplementary cards.',
    ],
    benefits: {
        legend: 'all benefits',
        title: 'Loan',
        items: [{
                title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                image: '/img/assets/benefits/slide-004.png',
                content: 'Sed a nisi vulputate, auctor odio ut, suscipit dui. Etiam in sem a ipsum dignissim euismod id nec tellus. Nunc dictum enim eros, vitae egestas velit pulvinar sed. Etiam aliquam libero sit amet ultrices commodo.',
            },
            {
                title: 'Pellentesque maximus mauris ut molestie suscipit.p',
                image: '/img/assets/benefits/slide-005.png',
                content: 'Nam a quam ac libero cursus finibus. Sed sed sem hendrerit, ultrices arcu sit amet, egestas elit. Phasellus tempor neque metus, sed rhoncus odio pellentesque at. Nam blandit lacus vel elit faucibus, eu tincidunt leo ultricies. Maecenas fermentum elementum leo tempus scelerisque. Ut mauris odio, interdum et euismod quis, iaculis ut est.',
            },
        ],
    },
}, ];

export {
    // GENERIC EXPORTS
    GENERIC_TITLE,
    GENERIC_SUBTITLE,
    FIELD_NAMES,
    END_PAGE_OPS,
    // VALUES
    SPENDING,
    YESNO,
    REWARDSTYPE,
    USE,
    CARD_USE,
    CARD_USE_LONG,
    INCOME,
    // CONTENT
    FEATURES_NBC_CARDS,
    FEATURES_LOAN,
    INSURANCE
};